module.exports = __webpack_public_path__ + "static/media/ic_eraser_disabled1_white.0ec307a0.svg";